export const SENSITIVE_TEXT_PATTERN =
  /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|bearer\s+[A-Z0-9._~+/=-]+|access[_-]?token|refresh[_-]?token|id[_-]?token|password|authorization|cookie|set-cookie)/i;

export function containsSensitiveText(value: unknown): boolean {
  if (typeof value === 'string') {
    return SENSITIVE_TEXT_PATTERN.test(value);
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  try {
    return SENSITIVE_TEXT_PATTERN.test(JSON.stringify(value));
  } catch {
    return false;
  }
}
